var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.29,44.71h-18.77v-2.79l7.52-7.56c2.29-2.32,3.8-3.97,4.53-4.96s1.28-1.95,1.64-2.89.55-1.95.55-3.03c0-1.52-.46-2.73-1.39-3.62s-2.21-1.34-3.85-1.34c-1.18,0-2.31.2-3.37.59s-2.24,1.1-3.54,2.13l-1.72-2.21c2.63-2.19,5.5-3.28,8.59-3.28,2.68,0,4.79.69,6.31,2.06s2.29,3.22,2.29,5.54c0,1.81-.51,3.6-1.52,5.37s-2.92,4.01-5.7,6.72l-6.25,6.11v.16h14.69v3.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN2);
export default __webpack_public_path__ + "static/media/n2.3e0f7623e4f6b9b0ac3bf1fc39e02dd4.svg";
export { ForwardRef as ReactComponent };